import { createStore } from 'vuex';

export default createStore({
    state: {
        serverToken: '',

        // >>>>  Production ServerIP
        // serverIp: 'http://8.210.195.51:1005',
        // frontendServerIp: 'http://8.210.195.51:1006',

        serverIp: 'https://newg2-backend.glwebapp.com',
        frontendServerIp: 'https://newg2.glwebapp.com',

        // serverIp: 'https://newg2-backend-uat.codemonkeykim.dev',
        // frontendServerIp: 'https://newg2.glwebapp.com',

        // serverIp: 'https://invdemoserver.glwebapp.com',
        // frontendServerIp: 'https://invdemo.glwebapp.com',

        // >>>>  Development ServerIP
        // serverIp: 'http://10.88.72.100:8000',
        // frontendServerIp: 'https://newg2-uat.codemonkeykim.dev',

        serverMediaPath: '/media/',
        serverMediaNoImage: '/media/assets/no_image.jpg',

        // Login Use
        isAuthenticated: false,
        userOnlinePK: '',
        userServerID: '',
        userShowName: '',

        language: '',

        printerIP: '',
        printerFlag: 'b',

        isTopLoading: false,
        isBlackLayout: false,

        isTableHideTable: false,
    },
    getters: {},
    mutations: {
        // Start this when first start the webapp
        initializeStore(state) {
            // Set Language
            if (localStorage.getItem('language')) {
                state.language = localStorage.getItem('language');
            } else {
                state.language = 'zh-hk';
                localStorage.setItem('language', 'zh-hk');
            }

            // Check is logged in
            if (localStorage.getItem('userOnlinePK')) {
                state.isAuthenticated = true;
                state.userOnlinePK = localStorage.getItem('userOnlinePK');
                state.userServerID = localStorage.getItem('userServerID');
                state.userShowName = localStorage.getItem('userShowName');
            } else {
                // Clear these stuff again (It should be clear on logout)
                state.isAuthenticated = false;
                state.userOnlinePK = '';
                state.userServerID = '';
                state.userShowName = '';
            }

            // Set Printing Stuff
            if (localStorage.getItem('printerIP')) {
                state.printerIP = localStorage.getItem('printerIP');
            } else {
                state.printerIP = '0.0.0.0';
            }
            if (localStorage.getItem('printerFlag')) {
                state.printerFlag = localStorage.getItem('printerFlag');
            } else {
                state.printerFlag = 'b';
            }

            // Set Table on Hide Image
            if (localStorage.getItem('hideImage')) {
                state.hideImage = localStorage.getItem('hideImage');
            } else {
                state.hideImage = 'f';
            }
        },

        // Set Server Token
        setServerToken(state, token) {
            state.serverToken = token;
        },

        // Set User Data after Login Success
        setUserLogin(state, userData) {
            state.isAuthenticated = true;
            state.userOnlinePK = userData.currentOnlineListId;
            state.userServerID = userData.userID;
            state.userShowName = userData.userShowName;
            localStorage.setItem('userOnlinePK', state.userOnlinePK);
            localStorage.setItem('userServerID', state.userServerID);
            localStorage.setItem('userShowName', state.userShowName);
        },

        // Set User Logout
        setUserLogout(state) {
            state.isAuthenticated = false;
            state.userOnlinePK = '';
            state.userServerID = '';
            state.userShowName = '';
            localStorage.removeItem('userOnlinePK');
            localStorage.removeItem('userServerID');
            localStorage.removeItem('userShowName');
        },

        // Language
        setLanguage(state) {
            const getLan = localStorage.getItem('language');
            if (getLan !== 'en') {
                this.state.language = 'en';
            } else {
                this.state.language = 'zh-hk';
            }
            localStorage.setItem('language', state.language);
            //i18n.locale = state.language
            console.log('Now language change to: ' + localStorage.getItem('language'));
        },

        // Set Is Top Loading
        setIsTopLoading(state, status) {
            state.isTopLoading = status;
        },

        // Set Is Black Layout
        setIsBlackLayout(state, status) {
            state.isBlackLayout = status;
        },
    },
    actions: {},
    modules: {},
});
